export const textAnalytics = {
	questionSettings: {
		editorQuestions: '.js-ta-editor-questions',
		editorAvailableQuestions: '.js-ta-editor-available-questions',
		editorAssignedQuestions: '.js-ta-editor-assigned-questions',
		editorQuestion: 'data-editor-question',
		editorQuestionSaveHandler: 'data-editor-question-save-handler',
	},
}
